module.exports = __webpack_public_path__ + "img/jll_logo_rgb.820cf1fa.svg";